const apps_sidebar = {
    account: 'Mein Konto',
    help: 'Hilfe'
}

export default apps_sidebar;